import { NGXLogger } from 'ngx-logger';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { EnterpriseInvoiceService } from '../EnterpriseInvoice.service';
import { DatatableHelperService } from '../../../../services/datatable-helper.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-enterprise-cashing-invoice',
  templateUrl: './enterprise-cashing-invoice.component.html',
  styleUrls: ['./enterprise-cashing-invoice.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  encapsulation: ViewEncapsulation.None,
  providers: [EnterpriseInvoiceService, DatatableHelperService],
})
export class EnterpriseCashingInvoiceComponent implements OnInit {
  //
  @Input() invoice: any = { amount: '' };
  @Output() onUpdate: EventEmitter<any> = new EventEmitter();
  form: UntypedFormGroup;
  /**
   * Texte affiché dans l'input, découplé de la valeur numérique. Ne JAMAIS
   * réinjecter un montant formaté avec séparateurs de milliers (pipe number
   * → « 1,001.01 ») : le parseur relit la virgule comme décimale et le
   * montant devient 1.00.
   */
  amountText: string = '';
  //
  constructor(
    // private translationLoader: FuseTranslationLoaderService,
    public translate: TranslateService,
    private formBuilder: UntypedFormBuilder,
    // public deliveryRequestTypeService: DeliveryRequestTypeService,
    // public deliveryRequestContentService: DeliveryRequestContentService,
    // public wrappingService: WrappingService,
    // public depositRequestService: DepositRequestService,
    // public paymentModesService: PaymentModesService,
    // private depositInService: DepositInService,
    // public dialog: MatDialog,
    // public router: Router,
    // private adapter: DateAdapter<any>,
    // private toastr: ToastrService,
    private logger: NGXLogger,
  ) {
    this.form = this.formBuilder.group({
      // cashing_amount: ["", [Validators.required]],
      // received_at: ["", [ValidatorHelper.dateTodaysOrLower]],
      amount: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    const initial = parseFloat(this.invoice?.amount);
    this.amountText = isNaN(initial) ? '0.00' : initial.toFixed(2);
  }

  // ngModelChange émet la VALEUR (pas un event DOM). Virgule ou point
  // acceptés comme séparateur décimal, espaces ignorés ; jamais de négatif
  // (plancher à 0).
  public onAmountChange(value: any): void {
    const raw = String(value ?? '');
    // Positif seulement : retirer tout caractère hors chiffres/./ , (dont -).
    const sanitized = raw.replace(/[^0-9.,]/g, '');
    if (sanitized !== raw) {
      this.form.get('amount')?.setValue(sanitized, { emitEvent: false });
    }
    this.amountText = sanitized;
    const parsed = parseFloat(sanitized.replace(',', '.'));
    let amount = isNaN(parsed) || parsed < 0 ? 0 : parsed;
    // Plafond : jamais plus que la BALANCE de la facture (reste à payer) —
    // pas de sur-encaissement par ligne.
    const max = parseFloat(this.invoice?.invoice?.event?.balance);
    if (!isNaN(max) && amount > max) {
      amount = max;
      const usesComma = String(this.amountText).includes(',');
      const fixed = amount.toFixed(2);
      this.amountText = usesComma ? fixed.replace('.', ',') : fixed;
    }
    this.invoice.amount = amount;
    this.onUpdate.emit();
  }

  // Au blur : format à 2 décimales en conservant le séparateur utilisé.
  public onAmountBlur(): void {
    const usesComma = String(this.amountText).includes(',');
    const fixed = Number(this.invoice?.amount ?? 0).toFixed(2);
    this.amountText = usesComma ? fixed.replace('.', ',') : fixed;
  }
}
